import { legacy_createStore as createStore } from 'redux'

const initialState = {
  sidebarShow: true,
  theme: 'light',
  moroccoTheme: localStorage.getItem('moroccoTheme') === 'true',
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      if (rest.moroccoTheme !== undefined) {
        localStorage.setItem('moroccoTheme', rest.moroccoTheme);
      }
      return { ...state, ...rest }
    default:
      return state
  }
}

try {
  localStorage.removeItem('sidebarUnfoldable')
} catch (e) {
  // storage unavailable
}

const store = createStore(changeState)
export default store
